import React, { Component } from 'react'
import { Container, Row, Col, Form, Button, Table, Card } from "react-bootstrap";

import C from '../lib/Config';
import '../App.css';
import swal from 'sweetalert';
const isEmail = (email) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
export default class ChemoTemplateToAOC extends Component {
    constructor(props) {
        super(props)
        this.state = {
            firstName: '',
            lastName: '',
            height: '',
            weight: '',
            bmi: '',
            protocolTitle: '',
            schedule: '',
            antiemeticRisk: '',
            antiallergicMedications: '',
            premedications: '',
            chemotherapyDoseAndMethodOfAdministration: '',
            numberOfDaysOfChemotherapyInEachCycle: '',
            postChemotherapyMedications: '',
            fnRisk: '',
            antithromboticProphylaxis: '',
            specialInstructionToNurse: '',
            specialInstructionToPatients: '',
            nextVisitInstructions: '',
            drugInteractions: '',
            reference: '',
            gcsfMedicines: '',
            boneModificationAgents: '',
            chemoTemplateEmailId : '',
            userName: '',
            chemoSupplements: '',
            chemoPremedications: '',
            instituteArr: [],
            chemoDt: '',         
        };
        this.tempSpecialInstructionToNurse = '';
        this.tempSpecialInstructionToPatients = '';
        this.tempNextVisitInstructions = '';
        this.tempDrugInteractions = '';
        this.handleChange = this.handleChange.bind(this);
        this.contentEditable = React.createRef();
    }
    
    
    componentDidMount () {
        this.setChemoSittingId();
        this.getChemoTemplateValue();
        this.getUserDetails();
        this.getAllInstitutes();
        const patientId = localStorage.getItem('PatientpatientId');

        if (patientId) {
            this.getPatientCaseDetail(patientId);
            this.getChemoSittingDetails(patientId);
        } else {
            console.error("Patient ID not found in localStorage");
        }

        const firstName = localStorage.getItem('PatientfirstName');
        const lastName = localStorage.getItem('PatientlastName');
        this.setState({
            firstName: firstName,
            lastName: lastName
          });
    }

    getChemoSittingDetails(patientId) {
        fetch(C.getUrl() + '/userCase/getChemoSittingDetails?patientId=' + patientId)
            .then(res => res.json())
            .then(res => {
                const resObj = JSON.parse(res.message);
                if (resObj.patientChemoSittingDTO && resObj.patientChemoSittingDTO.chemoDt) {
                    // Convert the date string to a more readable format
                    const date = new Date(resObj.patientChemoSittingDTO.chemoDt);
                const chemoDt = date.toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                }).replace(/\//g, '/');
                    this.setState({ chemoDt });
                }
            })
            .catch(err => {
                console.log("Error : " + err);
            });
    }

    getPatientCaseDetail(patientId) {
        // Validate patientId before making API call
        if (!patientId || patientId === 'undefined' || patientId === undefined) {
            console.error("Patient ID is undefined or invalid");
            return;
        }
        
        fetch(C.getUrl() + '/userCase/getPatientSummaryDetails?patientId=' + patientId)
            .then(res => res.json())
            .then(res => {
                console.log("Full API response:", res);
                const resObj = JSON.parse(res.message);
                console.log("Parsed response object:", resObj);
                const instituteName = resObj.patientDetailsDto.instituteDto.instituteName;
                const height = resObj.patientDetailsDto?.height 
                    ? `${resObj.patientDetailsDto.height} ${resObj.patientDetailsDto.heightUnitDto.unitName}`
                    : "N/A";
                const weight = resObj.patientDetailsDto?.weight 
                    ? `${resObj.patientDetailsDto.weight} ${resObj.patientDetailsDto.weightUnitDto.unitName}`
                    : "N/A";
                this.setState({ instituteName, height, weight }, this.calculateBMI);
 
            })
            .catch(err => {
                console.log("Error: " + err);
                this.setState({ instituteName: 'Error fetching institute name' });
            });
    }
    setChemoSittingId() {
        let chemoSittingId = 1; // Default value or handle it as needed
        if (this.props.location && this.props.location.search) {
            chemoSittingId = this.props.location.search.slice(3);
        }
        this.setState({ chemoSittingId }); // Store it in state
    }

    // The template API returns `null` (not '') for any column that was never filled in.
    // The old `field.length === 0` checks threw a TypeError on those nulls, which rejected
    // the whole .then() chain — so every field parsed AFTER the first null one was silently
    // dropped. That matters more here than on the other templates: sendToAOC builds its
    // payload from this.state, so a dropped field was POSTed to AOC as "Nil".
    // Treat null/undefined/'' uniformly as 'Nil' instead.
    orNil(value) {
        return (value === null || value === undefined || String(value).length === 0) ? 'Nil' : value;
    }

    getChemoTemplateValue() {
        var chemoSittingId = 1;
        if (this.props.location && this.props.location.search) {
            chemoSittingId = this.props.location.search.slice(3);
        }
        return fetch(C.getUrl() + '/userCase/getChemoTemplateForNurse/' + chemoSittingId)
        .then(res => res.json())
        .then(res => {
            let resObj = res;
            console.log(resObj);
            if (resObj.statusCode == 200 && resObj.message !== 'No record found.') {
                let tempData = JSON.parse(resObj.message);
                console.log(resObj.message);

                this.setState({ protocolTitle: tempData.protocolName });
                this.setState({ schedule: tempData.schedule });
                this.setState({ antiemeticRisk: this.orNil(tempData.antiemeticRisk) });
                this.setState({ antiallergicMedications: this.orNil(tempData.antiallergicMedications) });
                this.setState({ premedications: this.orNil(tempData.premedications) });
                this.setState({ chemotherapyDoseAndMethodOfAdministration: this.orNil(tempData.chemotherapyDoseAndMethodOfAdministration) });
                this.setState({ numberOfDaysOfChemotherapyInEachCycle: this.orNil(tempData.numberOfDaysOfChemotherapyInEachCycle) });
                this.setState({ postChemotherapyMedications: this.orNil(tempData.postChemotherapyMedications) });
                this.setState({ fnRisk: this.orNil(tempData.fnRisk) });
                this.setState({ antithromboticProphylaxis: this.orNil(tempData.antithromboticProphylaxis) });
                this.setState({ specialInstructionToNurse: tempData.specialInstructionToNurse });
                this.setState({ specialInstructionToPatients: tempData.specialInstructionToPatients });
                this.setState({ nextVisitInstructions: tempData.nextVisitInstructions });
                this.setState({ drugInteractions: this.orNil(tempData.drugInteractions) });
                this.setState({ reference: this.orNil(tempData.reference) });
                this.setState({ gcsfMedicines: this.orNil(tempData.gcsfMedicines) });
                this.setState({ boneModificationAgents: this.orNil(tempData.boneModificationAgents) });
                this.setState({ chemoSupplements: this.orNil(tempData.chemoSupplements) });
                this.setState({ chemoPremedications: this.orNil(tempData.chemoPremedications) });
            }
        })
        .catch(err => {
            // Log the error object (not a string concat) so the stack survives.
            console.error('[ChemoTemplateToAOC] getChemoTemplateValue FAILED — remaining fields were not applied', err);
        });
    }


    sendToAOC = async () => {
        try {
            // Get chemo sitting ID
            const chemoSittingId = this.props.location?.search ? 
                this.props.location.search.slice(3) : 1;
    
            // Get patient ID from localStorage
            const patientId = localStorage.getItem('PatientpatientId');
            
            if (!patientId) {
                throw new Error('Patient ID not found in localStorage');
            }
    
            // First get the chemo template data
            const templateResponse = await fetch(
                C.getUrl() + '/userCase/getChemoTemplateForNurse/' + chemoSittingId
            );
            
            if (!templateResponse.ok) {
                throw new Error('Failed to fetch template data');
            }
    
            const templateResult = await templateResponse.json();
            
            if (templateResult.statusCode === 200 && templateResult.message !== 'No record found.') {
                const tempData = JSON.parse(templateResult.message);
                
                // Prepare payload for AOC API
                const aocPayload = {
                    "MidasPatientId": patientId, // Add patient ID from localStorage
                    "AntithromboticProphylaxis": this.state.antithromboticProphylaxis || "Nil",
                    "chemoSupplements": this.state.chemoSupplements || "Nil",
                    "reference": this.state.reference || "Nil",
                    "protocolName": this.state.protocolTitle || "Nil",
                    "nextVisitInstructions": this.state.nextVisitInstructions || "Nil",
                    "chemotherapyDoseMethOfAdmt": this.state.chemotherapyDoseAndMethodOfAdministration || "Nil",
                    "gcsfMedicines": this.state.gcsfMedicines || "Nil",
                    "drugInteractions": this.state.drugInteractions || "Nil",
                    "chemoPremedications": this.state.chemoPremedications || "Nil",
                    "noOfDaysOfChemoInEachCycle": this.state.numberOfDaysOfChemotherapyInEachCycle || "Nil",
                    "specialInstructionToNurse": this.state.specialInstructionToNurse || "Nil",
                    "antiemeticRisk": this.state.antiemeticRisk || "Nil",
                    "specialInstructionToPatients": this.state.specialInstructionToPatients || "Nil",
                    "fnRisk": this.state.fnRisk || "Nil"
                };
    
                // Send data to AOC API
                const aocResponse = await fetch('https://aoclinicswebapi.acssel.com/api/Doctor/PatientchemotherpySave', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(aocPayload)
                });
    
                if (!aocResponse.ok) {
                    throw new Error('Failed to send data to AOC');
                }
    
                const aocResult = await aocResponse.json();
                
                // Show success message
                swal({
                    title: "Success!",
                    text: "Details have been successfully sent to AOC!",
                    icon: "success",
                    buttons: false,
                    timer: 2000
                });
    
            } else {
                throw new Error('No template data found');
            }
            
        } catch (error) {
            console.error('Error:', error);
            
            swal({
                title: "Error!",
                text: error.message || "Failed to send details to AOC",
                icon: "error",
                buttons: false,
                timer: 2000
            });
        }
    }

    getUserDetails() {
        const userdetail = {
            firstName: localStorage.getItem("firstName") ? localStorage.getItem("firstName") : "",
            lastName: localStorage.getItem("lastName") ? localStorage.getItem("lastName") : "",
        };

        const fullName = `${userdetail.firstName} ${userdetail.lastName}`;
        this.setState({ userName: fullName});
    }

    
    printForm(){
        window.print();
    }

    sendChemoTemplateMail() {
        var emailId = this.state.chemoTemplateEmailId;
        if(emailId === ''){
            alert("Please give Email Id first!!!");
        }else if(emailId.indexOf(',') != -1){
            var array = emailId.split(',')
            for(var i = 0; i < array.length; i++) {
                if(!isEmail(array[i])){
                    alert("Invalid Email Id : "+array[i]);
                }
            }
        }else if (!isEmail(emailId)) {
            alert("Invalid Email Id : "+emailId);
        }else{
            let data = {
                "ChemoTeplateData" : {
                    "1" : {"Protocol title" : this.state.protocolTitle},
                    "2" : {"Antiemetic risk" : this.state.antiemeticRisk},
                    "3" : {"Antiallergic medications" : this.state.antiallergicMedications},
                    "4" : {"GCSF medicines" : this.state.gcsfMedicines},
                    "5" : {"Bone modification agents" : this.state.boneModificationAgents},
                    "6" : {"Premedications" : this.state.premedications},
                    "7" : {"Chemotherapy dose and method of administration" : this.state.chemotherapyDoseAndMethodOfAdministration},
                    "8" : {"Number of days of chemotherapy in each cycle" : this.state.numberOfDaysOfChemotherapyInEachCycle},
                    "9" : {"Post chemotherapy medications" : this.state.postChemotherapyMedications},
                    "10" : {"FN risk" : this.state.fnRisk},
                    "11" : {"Antithrombotic prophylaxis" : this.state.antithromboticProphylaxis},
                    "12" : {"Special instruction to Nurse" : this.state.specialInstructionToNurse},
                    "13" : {"Special instruction to patients" : this.state.specialInstructionToPatients},
                    "14" : {"Next visit instructions" : this.state.nextVisitInstructions},
                    "15" : {"Drug interactions" : this.state.drugInteractions},
                    "16" : {"Reference" : this.state.reference}
                },
                "EmailId" : this.state.chemoTemplateEmailId
            }
            console.log(JSON.stringify(data));
            return fetch(C.getUrl() + '/email/sendChemoTemplateMail', {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(res => res.json())
            .then(res => {
                let obj = res;
                let error = obj.subErrors;
                if (error !== null && error !== "") {
                    alert(error);
                } else {
                    alert(obj.message);
                }
            })
            .catch(err => {
                console.log("Error : " + err);
            });
        }
    }

    handleChange(event) {
        if (event.target.name == 'chemoTemplateEmailId') {
            this.setState({ chemoTemplateEmailId: event.target.value });
        }
    } 
    handleChange(event) {
        const { name, value } = event.target;
        this.setState({ [name]: value }, () => {
            if (name === "height" || name === "weight") {
                this.calculateBMI();
            }
        });
    }

    getAllInstitutes = async () => {
        // Retrieve userId from local storage
        const userId = localStorage.getItem("userId");
        if (!userId) {
            console.error("User ID is not set in local storage.");
            return;
        }
    
        try {
            // Use C.getUrl() to construct the endpoint URL
            const response = await fetch(C.getUrl() + "/institute/getAllInstituteByUserId/" + userId);
            const resObj = await response.json();
    
            const arr = resObj.map((item) => ({
                id: item.instituteId,
                name: item.instituteName,
            }));
    
            console.log("--> INSTITUTE ARR : ", JSON.stringify(arr));
            this.setState({ instituteArr: arr });
        } catch (err) {
            console.error("Error: ", err);
        }
    };

    sendNEXTVISITUpdatedInstructions() {
        if (!this.state.chemoSittingId) {
            alert('Chemotherapy Sitting ID is required.');
            return;
        }
        const data = {
            nextVisitInstructions: this.state.nextVisitInstructions, // Adjust this as necessary
        };
    
        console.log("Data being sent:", JSON.stringify(data));
    
        return fetch(C.getUrl() + `/userCase/updateChemoInstructions/${this.state.chemoSittingId}`, {
            method: 'PUT',
            mode: 'cors',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
            }
        })
        
        .then(res => res.json())
        .then(res => {
            if (res.subErrors) {
                alert(`Error: ${res.subErrors}`);
            } else if (res.error) {
                alert(`Error: ${res.error}`);
            } else {
                alert('Special instructions updated successfully!');
                this.setState({ specialInstructionsUpdated: true });
                setTimeout(() => {
                    this.setState({ specialInstructionsUpdated: false });
                }, 3000);
            }
        })
        .catch(err => {
            console.error("Request error:", err);
            this.setState({ errorAlertshow: true });
            setTimeout(() => {
                this.setState({ errorAlertshow: false });
            }, 3000);
        });
    }

    sendDRUGUpdatedInstructions() {
        if (!this.state.chemoSittingId) {
            alert('Chemotherapy Sitting ID is required.');
            return;
        }
        const data = {
            drugInteractions: this.state.drugInteractions, // Adjust this as necessary
        };
    
        console.log("Data being sent:", JSON.stringify(data));
    
        return fetch(C.getUrl() + `/userCase/updateChemoInstructions/${this.state.chemoSittingId}`, {
            method: 'PUT',
            mode: 'cors',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
            }
        })
        
        .then(res => res.json())
        .then(res => {
            if (res.subErrors) {
                alert(`Error: ${res.subErrors}`);
            } else if (res.error) {
                alert(`Error: ${res.error}`);
            } else {
                alert('Special instructions updated successfully!');
                this.setState({ specialInstructionsUpdated: true });
                setTimeout(() => {
                    this.setState({ specialInstructionsUpdated: false });
                }, 3000);
            }
        })
        .catch(err => {
            console.error("Request error:", err);
            this.setState({ errorAlertshow: true });
            setTimeout(() => {
                this.setState({ errorAlertshow: false });
            }, 3000);
        });
    }
    
    sendNurseUpdatedInstructions() {
        if (!this.state.chemoSittingId) {
            alert('Chemotherapy Sitting ID is required.');
            return;
        }
    
        const data = {
            nurseInstructions: this.state.specialInstructionToNurse, // Adjust this as necessary
        };
    
        console.log("Data being sent:", JSON.stringify(data));
    
        return fetch(C.getUrl() + `/userCase/updateChemoInstructions/${this.state.chemoSittingId}`, {
            method: 'PUT',
            mode: 'cors',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
            }
        })
        
        .then(res => res.json())
        .then(res => {
            if (res.subErrors) {
                alert(`Error: ${res.subErrors}`);
            } else if (res.error) {
                alert(`Error: ${res.error}`);
            } else {
                alert('Special instructions updated successfully!');
                this.setState({ specialInstructionsUpdated: true });
                setTimeout(() => {
                    this.setState({ specialInstructionsUpdated: false });
                }, 3000);
            }
        })
        .catch(err => {
            console.error("Request error:", err);
            this.setState({ errorAlertshow: true });
            setTimeout(() => {
                this.setState({ errorAlertshow: false });
            }, 3000);
        });
    }
    
// New function to update chemo instructions
 sendPatientUpdatedInstructions() {
    if (!this.state.chemoSittingId) {
        alert('Chemotherapy Sitting ID is required.');
        return;
    }

    const data = {
        patientInstructions: this.state.specialInstructionToPatients, // Adjust this as necessary
    };

    console.log("Data being sent:", JSON.stringify(data));

    return fetch(C.getUrl() + `/userCase/updateChemoInstructions/${this.state.chemoSittingId}`, {
        method: 'PUT',
        mode: 'cors',
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
        }
    })
    
    .then(res => res.json())
    .then(res => {
        if (res.subErrors) {
            alert(`Error: ${res.subErrors}`);
        } else if (res.error) {
            alert(`Error: ${res.error}`);
        } else {
            alert('Special instructions updated successfully!');
            this.setState({ specialInstructionsUpdated: true });
            setTimeout(() => {
                this.setState({ specialInstructionsUpdated: false });
            }, 3000);
        }
    })
    .catch(err => {
        console.error("Request error:", err);
        this.setState({ errorAlertshow: true });
        setTimeout(() => {
            this.setState({ errorAlertshow: false });
        }, 3000);
    });
}

handleChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
}
handleChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
}
handlePrint = () => {
    this.setState({ isPrinting: true }, () => {
        window.print();
        setTimeout(() => {
            this.setState({ isPrinting: false });
        }, 500);
    });
}

handleContentChange = (e) => {
    this.setState({ specialInstructionToPatients: e.currentTarget.textContent });
}
handleContentChange1 = (e) => {
    this.setState({ specialInstructionToNurse: e.currentTarget.textContent });
}
handleContentChange2 = (e) => {
    this.setState({ drugInteractions: e.currentTarget.textContent });
}
handleContentChange3 = (e) => {
    this.setState({ nextVisitInstructions: e.currentTarget.textContent });
}
calculateBMI = () => {
    const { height, weight } = this.state;
    if (height && weight) {
        // Parse the numeric values from height and weight strings
        const heightValue = parseFloat(height); // Assuming height is in cm
        const weightValue = parseFloat(weight); // Assuming weight is in kg

        if (heightValue > 0 && weightValue > 0) {
            const heightInMeters = heightValue / 100; // Convert cm to meters
            const bmi = (weightValue / (heightInMeters ** 2)).toFixed(1);
            this.setState({ bmi });
        } else {
            this.setState({ bmi: 'N/A' });
        }
    }
};

 // Handler to update temp variables during editing
 handleContentInput = (tempField, value) => {
    this[tempField] = value;
};

// Handler to update state on blur
handleContentBlur = (stateField, tempField) => {
    this.setState({ [stateField]: this[tempField] });
};
    render() {
        const { instituteArr,height, weight,bmi } = this.state;
        return (
            <div className="d-flex" id="wrapper">
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Container fluid>
                            <div className="app-content">
                                <section className="section" id="accordion">
                                    <div className="form formBackground">
                                        <div className="lightSeperator">
                                        <Card className="custom-card mb-4">
                                            <Card.Body>
                                                <Row>
                                                    <Col lg="12" className="text-center">
                                                         <h2 className="section-title text-center">
                                                         <b>{this.state.instituteName}</b>
                                                        </h2>
                                                    </Col>
                                                </Row>

                                                <hr />
                                                <Row className="d-flex justify-content-between align-items-center">
                                                    <Col lg="12">
                                                    <h1 className="section-title"><b>Dr. {this.state.userName}</b></h1><br></br>

                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs={12}>
                                                        <div style={{ position: 'relative', marginBottom: '10px' }}>
                                                            <div style={{ display: 'inline-block' }}>
                                                                <span style={{ fontWeight: 'bold', marginRight: '10px' }}>Patient Name:</span>
                                                                <span>{this.state.firstName} {this.state.lastName}</span>
                                                            </div>
                                                            <div style={{ 
                                                                position: 'absolute', 
                                                                right: '0', 
                                                                top: '0',
                                                                display: 'inline-block' 
                                                            }}>
                                                                <span style={{ fontWeight: 'bold', marginRight: '10px' }}>Date:</span>
                                                                <span>{this.state.chemoDt || 'N/A'}</span>
                                                            </div>
                                                        </div>
                                                        <div style={{ marginBottom: '10px' }}>
                                                            <span style={{ fontWeight: 'bold', display: 'inline-block', width: '120px' }}>Height:</span>
                                                            <span>{height}</span>
                                                        </div>
                                                        <div style={{ marginBottom: '10px' }}>
                                                            <span style={{ fontWeight: 'bold', display: 'inline-block', width: '120px' }}>Weight:</span>
                                                            <span>{weight}</span>
                                                        </div>
                                                        <div style={{ marginBottom: '10px' }}>
                                                            <span style={{ fontWeight: 'bold', display: 'inline-block', width: '120px' }}>BMI:</span>
                                                            <span>{bmi}</span>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>                    
                                            <Row>
                                                <Col lg="12">
                                                    <Table responsive="lg" striped bordered className="hoverable-table">
                                                        <tbody>
                                                            
                                                            <tr>
                                                                <td><b>Protocol title</b></td>
                                                                <td style={{ whiteSpace: "pre-wrap" }}>{this.state.protocolTitle}</td>
                                                            </tr>
                                                            {this.state.chemoPremedications !== 'Nil' && (
                                                            <tr>
                                                                <td><b>Pre-Medications</b></td>
                                                                <td style={{ whiteSpace: "pre-wrap" }}>{this.state.chemoPremedications}</td>
                                                            </tr>
                                                        )}
                                                        {this.state.chemoSupplements !== 'Nil' && (
                                                            <tr>
                                                                <td><b>Supplements</b></td>
                                                                <td style={{ whiteSpace: "pre-wrap" }}>{this.state.chemoSupplements}</td>
                                                            </tr>
                                                        )}
                                                            <tr>
                                                                <td><b>Antiemetic risk</b></td>
                                                                <td style={{ whiteSpace: "pre-wrap" }}>{this.state.antiemeticRisk}</td>
                                                            </tr>
                                                            <tr>
                                                                <td><b>GCSF medicines</b></td>
                                                                <td style={{ whiteSpace: "pre-wrap" }}>{this.state.gcsfMedicines}</td>
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg="12">
                                                    <Card className="custom-card">
                                                        <Card.Header className="fixed-header"><b>CHEMOTHERAPY DOSE AND METHOD OF ADMINISTRATION</b></Card.Header>
                                                        <Card.Body className="scrollable-card-body">
                                                            <Card.Text style={{ whiteSpace: "pre-wrap" }}>
                                                                {this.state.chemotherapyDoseAndMethodOfAdministration}
                                                            </Card.Text>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg="12">
                                                    <Table responsive="lg" striped bordered className="hoverable-table">
                                                        <tbody>
                                                            <tr>
                                                                <td><b>Number of days of chemotherapy in each cycle</b></td>
                                                                <td style={{ whiteSpace: "pre-wrap" }}>{this.state.numberOfDaysOfChemotherapyInEachCycle}</td>
                                                            </tr>
                                                            <tr>
                                                                <td><b>FN risk</b></td>
                                                                <td style={{ whiteSpace: "pre-wrap" }}>{this.state.fnRisk}</td>
                                                            </tr>
                                                            <tr>
                                                                <td><b>Antithrombotic prophylaxis</b></td>
                                                                <td style={{ whiteSpace: "pre-wrap" }}>{this.state.antithromboticProphylaxis}</td>
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Row>

                                                </Row>

                                                <Col lg="12">
                                                    <Card className="custom-card">
                                                        <Card.Header className="fixed-header"><b>SPECIAL INSTRUCTIONS FOR NURSE</b></Card.Header>
                                                        
                                                        <Card.Body className="scrollable-card-body">
                                                            <Card.Text
                                                                //ref={this.contentEditable}
                                                                contentEditable
                                                                onInput={(e) => this.handleContentInput('tempSpecialInstructionToNurse', e.target.innerText)}
                                                                onBlur={() => this.handleContentBlur('specialInstructionToNurse', 'tempSpecialInstructionToNurse')}
                                                                style={{ 
                                                                    whiteSpace: "pre-wrap",
                                                                    margin: '15px', 
                                                                    padding: '10px',
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '5px',
                                                                    cursor: 'text'
                                                                }}
                                                            >
                                                                {this.state.specialInstructionToNurse}
                                                            </Card.Text>
                                                        </Card.Body>

                                                    </Card>
                                                    <Col lg="12" className="text-center" style={{ marginBottom: '20px' }}>
                                                        <Button
                                                            variant="secondary"
                                                            className="btn-primary mr-2 btn-primary mr-2 no-print"
                                                            onClick={() => this.sendNurseUpdatedInstructions()}
                                                        >
                                                            Save
                                                        </Button>
                                                    </Col>
                                                    <Card className="custom-card">
                                                        <Card.Header className="fixed-header"><b>SPECIAL INSTRUCTIONS TO PATIENTS</b></Card.Header>
                                                        
                                                        <Card.Body className="scrollable-card-body">
                                                            <Card.Text
                                                                //ref={this.contentEditable}
                                                                contentEditable
                                                                onInput={(e) => this.handleContentInput('tempSpecialInstructionToPatients', e.target.innerText)}
                                                                onBlur={() => this.handleContentBlur('specialInstructionToPatients', 'tempSpecialInstructionToPatients')}
                                                                style={{ 
                                                                    whiteSpace: "pre-wrap",
                                                                    margin: '15px', 
                                                                    padding: '10px', 
                                                                    border: '1px solid #ccc', 
                                                                    borderRadius: '5px',
                                                                    cursor: 'text'
                                                                }}
                                                                //onChange={(e) => this.setState({ specialInstructionToPatients: e.target.value })}
                                                            >
                                                                {this.state.specialInstructionToPatients}
                                                            </Card.Text>
                                                        </Card.Body>

                                                    </Card>
                                                    <Col lg="12" className="text-center" style={{ marginBottom: '20px' }}>
                                                        <Button
                                                            variant="secondary"
                                                            className="btn-primary mr-2 btn-primary mr-2 no-print"
                                                            onClick={() => this.sendPatientUpdatedInstructions()}
                                                        >
                                                            Save
                                                        </Button>
                                                    </Col>
                                                    <Card className="custom-card">
                                                        <Card.Header className="fixed-header"><b>NEXT VISIT INSTRUCTIONS</b></Card.Header>
                                                        <Card.Body className="scrollable-card-body">
                                                        <Card.Text
                                                            //ref={this.contentEditable}
                                                            contentEditable
                                                            onInput={(e) => this.handleContentInput('tempNextVisitInstructions', e.target.innerText)}
                                                            onBlur={() => this.handleContentBlur('nextVisitInstructions', 'tempNextVisitInstructions')}
                                                            style={{ 
                                                                whiteSpace: "pre-wrap",
                                                                margin: '15px', 
                                                                padding: '10px', 
                                                                border: '1px solid #ccc', 
                                                                borderRadius: '5px',
                                                                cursor: 'text'
                                                            }}
                                                        >
                                                            {this.state.nextVisitInstructions}
                                                        </Card.Text>
                                                        </Card.Body>
                                                    </Card>
                                                    <Col lg="12" className="text-center" style={{ marginBottom: '20px' }}>
                                                        <Button
                                                            variant="secondary"
                                                            className="btn-primary mr-2 btn-primary mr-2 no-print"
                                                            onClick={() => this.sendNEXTVISITUpdatedInstructions()}
                                                        >
                                                            Save
                                                        </Button>
                                                    </Col>
                                                    <Card className="custom-card">
                                                        <Card.Header className="fixed-header"><b>DRUG INTERACTIONS</b></Card.Header>
                                                        
                                                        <Card.Body className="scrollable-card-body">
                                                    <Card.Text
                                                        //ref={this.contentEditable}
                                                        contentEditable
                                                        onInput={(e) => this.handleContentInput('tempDrugInteractions', e.target.innerText)}
                                                        onBlur={() => this.handleContentBlur('drugInteractions', 'tempDrugInteractions')}
                                                        style={{ 
                                                            whiteSpace: "pre-wrap",
                                                            margin: '15px', 
                                                            padding: '10px',
                                                            border: '1px solid #ccc',
                                                            borderRadius: '5px',
                                                            cursor: 'text'
                                                        }}
                                                    >
                                                        {this.state.drugInteractions}
                                                    </Card.Text>
                                                </Card.Body>
                                                   </Card>
                                                   <Col lg="12" className="text-center" style={{ marginBottom: '20px' }}>
                                                        <Button
                                                            variant="secondary"
                                                            className="btn-primary mr-2 btn-primary mr-2 no-print"
                                                            onClick={() => this.sendDRUGUpdatedInstructions()}
                                                        >
                                                            Save
                                                        </Button>
                                                    </Col>
                                                   <Card className="custom-card">
                                                        <Card.Header className="fixed-header"><b>REFERENCE</b></Card.Header>
                                                        <Card.Body className="scrollable-card-body">
                                                            <Card.Text style={{ whiteSpace: "pre-wrap" }}>
                                                                {this.state.reference}
                                                            </Card.Text>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg="12">
                                                    <Table responsive="lg" striped bordered className="hoverable-table">
                                                        <tbody>
                                                            
                                                            <tr>
                                                                <td>
                                                                    <b>Email Id's</b><br />
                                                                    <small>If Multiple please provide Comma (,) in between.</small>
                                                                </td>
                                                                <td>
                                                                    <Form.Control
                                                                        type="text"
                                                                        placeholder="Enter Email Id"
                                                                        defaultValue={this.state.chemoTemplateEmailId}
                                                                        name="chemoTemplateEmailId"
                                                                        onChange={this.handleChange}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row>
                                            <Row className="submit">
                                                <Col lg="12" className="text-center">
                                                    <Button
                                                        variant="secondary"
                                                        className="btn-primary mr-2 btn-primary mr-2 no-print"
                                                        onClick={() => this.printForm()}
                                                    >
                                                        Print
                                                    </Button>
                                                    <Button
                                                        variant="secondary"
                                                        className="btn-primary mr-2 btn-primary mr-2 no-print"
                                                        onClick={() => this.sendChemoTemplateMail()}
                                                    >
                                                        Send Mail
                                                    </Button>
                                                    <Button
                                                        variant="secondary"
                                                        className="btn-primary mr-2 btn-primary mr-2 no-print"
                                                        onClick={() => this.sendToAOC()}
                                                    >
                                                        Send to AOC
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </Container>
                    </div>
                </div>
            </div>
        );
    }

}